import api from "./client";

export const listPVModules = async () => {
  const { data } = await api.get("/pvmodules/");
  return data;
};

export const listPVModulesBySite = async (siteId) => {
  const { data } = await api.get(`/pvmodules/site/${siteId}`);
  return data;
};

export const createPVModule = async (payload) => {
  const { data } = await api.post("/pvmodules/", payload);
  return data;
};

// ✅ NEW: update PV module (PUT)
export const updatePVModule = async (id, payload) => {
  const { data } = await api.put(`/pvmodules/${id}`, payload);
  return data;
};

export const deletePVModule = async (id) => {
  const { data } = await api.delete(`/pvmodules/${id}/`);
  return data;
};

// ✅ check if PV module can be safely deleted
export const canDeletePVModule = async (id) => {
  const { data } = await api.get(`/pvmodules/${id}/can_delete`);
  return data;
};
